import http from "./Http";

const getMenuOptionsByUserId = async (id) => {
    const res = await http.get(`/user-permissions/${id}`);
    return res.data;
};

const UserPermissionsService = {
    getMenuOptionsByUserId,
};

export default UserPermissionsService;
